<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 v-if="article.id === undefined" slot="header" class="card-title">Création d'un article</h4>
        <h4 v-if="article.id !== undefined" slot="header" class="card-title">Article : {{ article.ref+' - '+article.name }}</h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="backToList()">
            <span><i class="fas fa-arrow-circle-left mr-2"></i> Retour</span>
          </n-button>
        </div>
        <div class="mr-4 ml-4 mb-4">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <form ref="command_form" @submit.prevent="save()">
            <div class="row mb-2">
              <div class="col-lg-2 ml-auto">
                <label class="input-label">Nom</label>
                <fg-input placeholder="M4 Clé" autocomplete="off" name="name" v-validate="'required'" :error="errors.first('name')"
                          v-model="article.name" style="margin-bottom: 28px" addon-left-icon="now-ui-icons shopping_tag-content"/>
              </div>
              <div class="col-lg-2">
                <label class="input-label">Référence</label>
                <fg-input placeholder="740100" autocomplete="off" name="ref" v-validate="'required'" :error="errors.first('ref')"
                          v-model="article.ref" style="margin-bottom: 28px" addon-left-icon="now-ui-icons shopping_tag-content"/>
              </div>
              <div class="col-lg-2">
                <label class="input-label">Type</label>
                <fg-input class="select" style="margin-bottom: 28px" name="type" v-model="article.type" v-validate="'required'">
                  <el-select :class="errors.first('type') ? 'has-error':''"  id="article" placeholder="Choisir un type d'article" v-model="article.type" filterable>
                    <el-option v-for="type in type_select_options" :key="type.id" :label="type.name" :value="type.id"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('type')">
                      {{ errors.first('type') }}
                    </div>
                  </slot>
                </fg-input>
              </div>
              <div class="col-lg-2 mr-auto">
                <div style="height: 30px">
                  <label class="switch-label">With device(s)</label>
                  <div class="switch-input" style="margin-bottom: 28px">
                    <n-switch style="margin-top: 15px;" v-model="article.device" on-text="Oui" off-text="Non"></n-switch>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <h5> Liste des métadonnées de création: </h5>
                <div class="row" v-for="(metadata, index_metadata) in article.metadatas" v-if="metadata.phase === 'CREATION'" :key="index_metadata">
                  <div class="col-lg-4 col-md-3 mb-3">
                    <label class="input-label">Ajouter un champ</label>
                    <fg-input class="select" name="field" v-model="metadata.metadata_id">
                      <el-select :id="'field_'+index_metadata" placeholder="Choisir un champ" v-model="metadata.metadata_id" filterable>
                        <el-option v-for="article in metadata_select_options" :key="article.id" :disabled="alreadySelected(article.id)" v-if="article.phase === 'CREATION'" :label="article.name" :value="article.id"></el-option>
                      </el-select>
                    </fg-input>
                  </div>

                  <div class="col-lg-4 col-md-3 mb-3">
                    <label class="input-label">Définir une valeur</label>
                    <fg-input class="select" name="field" v-model="metadata.value_type">
                      <el-select :id="'value_type_'+index_metadata" placeholder="Choisir une valeur" v-model="metadata.value_type" filterable>
                        <el-option v-for="value_type in value_type_options" :key="value_type.value" :label="value_type.label" :value="value_type.value"></el-option>
                      </el-select>
                    </fg-input>
                  </div>

                  <div class="col-lg-3 col-md-3 mb-3">

                    <div v-if="!isSelectMetadata(metadata.metadata_id) && metadata.value_type !== null">
                      <label class="input-label">Valeur</label>
                      <fg-input :disabled="metadata.value_type === null" placeholder="ex: Clé" autocomplete="off" :name="'value'+index_metadata"
                                v-model="metadata.value" addon-left-icon="now-ui-icons fas fa-info"/>
                    </div>

                    <div v-if="isSelectMetadata(metadata.metadata_id) && metadata.value_type !== null">
                      <fg-input class="select" name="field" v-model="metadata.value">
                        <el-select :id="'creation_select_'+index_metadata" placeholder="Choisir un champ" :disabled="metadata.value_type === null"  v-model="metadata.value" filterable>
                          <el-option v-for="option in metadata_array_options(metadata.metadata_id)" :key="option.value"  :label="option.value" :value="option.value"></el-option>
                        </el-select>
                      </fg-input>
                    </div>


                  </div>

                  <div class="col-lg-1 col-md-3 mb-3 text-center">
                    <div class="mt-2"  style="cursor: pointer; border-radius: 10px; border: 2px solid #555; width: fit-content; margin-left: -5px;" @click="removeMetadataToForm(index_metadata)">
                      <i class="fas fa-times" style="color: #555; padding: 0px 6px"></i>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <n-button type="primary" class="btn btn-sm btn-primary mr-auto ml-auto mt-2" @click.native="addMetadataToForm('CREATION')">
                      <span><i class="fas fa-plus"></i></span>
                    </n-button>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <h5> Liste des métadonnées de préparation: </h5>
                <div class="row" v-for="(metadata, index_metadata) in article.metadatas" v-if="metadata.phase === 'PREPARATION'" :key="index_metadata">
                  <div class="col-lg-4 col-md-3 mb-3">
                    <label class="input-label">Ajouter un champ</label>
                    <fg-input class="select" name="field" v-model="metadata.metadata_id">
                      <el-select :id="'field_'+index_metadata" placeholder="Choisir un champ" v-model="metadata.metadata_id" filterable>
                        <el-option v-for="article in metadata_select_options" :key="article.id" v-if="article.phase === 'PREPARATION'" :disabled="alreadySelected(article.id)" :label="article.name" :value="article.id"></el-option>
                      </el-select>
                    </fg-input>
                  </div>

                  <div class="col-lg-4 col-md-3 mb-3">
                    <label class="input-label">Définir une valeur</label>
                    <fg-input class="select" name="field" v-model="metadata.value_type">
                      <el-select :id="'value_type_'+index_metadata" placeholder="Choisir une valeur" v-model="metadata.value_type" filterable>
                        <el-option v-for="value_type in value_type_options" :key="value_type.value" :label="value_type.label" :value="value_type.value"></el-option>
                      </el-select>
                    </fg-input>
                  </div>

                  <div class="col-lg-3 col-md-3 mb-3">
                    <div v-if="!isSelectMetadata(metadata.metadata_id) && metadata.value_type !== null">
                      <label class="input-label">Valeur</label>
                      <fg-input :disabled="metadata.value_type === null" placeholder="ex: Clé" autocomplete="off" :name="'value'+index_metadata"
                                v-model="metadata.value" addon-left-icon="now-ui-icons fas fa-info"/>
                    </div>

                    <div v-if="isSelectMetadata(metadata.metadata_id) && metadata.value_type !== null">
                      <fg-input class="select" name="field" v-model="metadata.value">
                        <el-select :id="'creation_select_'+index_metadata" placeholder="Choisir un champ" :disabled="metadata.value_type === null"  v-model="metadata.value" filterable>
                          <el-option v-for="option in metadata_array_options(metadata.metadata_id)" :key="option.value"  :label="option.value" :value="option.value"></el-option>
                        </el-select>
                      </fg-input>
                    </div>

                  </div>

                  <div class="col-lg-1 col-md-3 mb-3">
                    <div class="mt-2"  style="cursor: pointer; border-radius: 10px; border: 2px solid #555; width: fit-content; margin-left: -5px;" @click="removeMetadataToForm(index_metadata)">
                      <i class="fas fa-times" style="color: #555; padding: 0px 6px"></i>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <n-button type="primary" class="btn btn-sm btn-primary mr-auto ml-auto mt-2" @click.native="addMetadataToForm('PREPARATION')">
                      <span><i class="fas fa-plus"></i></span>
                    </n-button>
                  </div>
                </div>

              </div>
            </div>
            <div class="row">
              <n-button type="primary" class="btn btn-sm btn-primary mr-auto ml-auto mt-4" @click.native="save()">
                <span> Enregistrer </span>
              </n-button>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui'
import NSwitch from "../../../components/Switch";
import Spinner from "../../../components/Spinner/Circle";
import Form from "vform";

export default {
  name: "ArticleForm",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    NSwitch,
    Spinner,
  },
  data() {
    return {
      isLoaded: false,

      type_select_options: [],
      metadata_select_options: [],
      metadata_by_id: [],

      value_type_options: [
        {label: 'Aucune', value: null},
        {label: 'Par défaut', value: 'default_value'},
        {label: 'Obligatoire', value: 'forced_value'},
      ],

      article: new Form({
        name: '',
        ref: '',
        type: '',
        device: false,
        metadatas: [
            {metadata_id: '', value_type: null, value: '', phase: 'CREATION'},
            {metadata_id: '', value_type: null, value: '', phase: 'PREPARATION'}
        ]
      })
    };
  },
  mounted() {
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`article/type/list`).then((response) => {
      this.type_select_options = response.data
    })
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`metadata/list`).then((response) => {
      this.metadata_select_options = response.data

      this.metadata_select_options.forEach(metadata => {
        this.metadata_by_id[metadata.id] = metadata
      })

      this.isLoaded = true
    })
    if (this.$route.params.article !== undefined){
      this.article.id = this.$route.params.article.id
      this.article.name = this.$route.params.article.name
      this.article.ref = this.$route.params.article.ref
      this.article.type = this.$route.params.article.articles_type_id
      this.article.device = this.$route.params.article.device
      this.article.metadatas = []

      this.$route.params.article.metadatas.forEach(metadata => {
        let value_type = null
        let value = null
        if(metadata['pivot']['parameters']['default value'] !== null){
          value_type = 'default_value'
          value = metadata['pivot']['parameters']['default value']
        }
        if(metadata['pivot']['parameters']['forced value'] !== null){
          value_type = 'forced_value'
          value = metadata['pivot']['parameters']['forced value']
        }

        this.article.metadatas.push({metadata_id: metadata['id'], value_type: value_type, value: value, phase: metadata.phase})
      })
    }
  },
  methods: {
    // Vérifie si la métadonnée n'est pas déjà utilisée
    alreadySelected(metadata_id){
      var metadata_with_id = this.article.metadatas.filter(metadata => metadata.metadata_id !== '');
      var metadata_id_used = metadata_with_id.map(metadata => metadata.metadata_id);

      return metadata_id_used.includes(metadata_id)
    },
    // Retourne un tableau d'option correspondant à une métadonnée du type 'select'
    metadata_array_options(metadata_id){
      return this.metadata_by_id[metadata_id].options.options
    },
    // Retourne si la métadonnée est du type 'select'
    isSelectMetadata(metadata_id) {
      if(this.metadata_by_id[metadata_id] !== undefined){
        return this.metadata_by_id[metadata_id].options.type === 'select'
      }
      return false
    },
    // Supprime la métadonnée correspondant à l'index passé en paramètre
    removeMetadataToForm(indexToRemove){
      this.article.metadatas.splice(indexToRemove, 1)
    },
    // Ajoute une métadonnée vide dans le formulaire
    addMetadataToForm(phase = 'CREATION'){
      this.article.metadatas.push({metadata_id: '', value_type: null, value: '', phase})
    },
    // Retourne à la liste des articles
    backToList() {
      this.$router.push({ name: 'Article List' })
    },
    // Enregistre la commande
    save(){
      this.$validator.validateAll().then( value => {
        if (value === true) {
          if(this.article.id !== undefined){
            this.article.post(process.env.VUE_APP_API_BASE_URL+`article/update`).catch(error => {
            }).then( response => {
              // Notification en cas de succès & redirection
              this.$notify({message: 'L\'article a bien été mis à jour', type: 'success', verticalAlign: 'bottom'})
              this.backToList();
            })
          } else {
            this.article.post(process.env.VUE_APP_API_BASE_URL+`article/add`).catch(error => {
            }).then( response => {
              // Notification en cas de succès & redirection
              this.$notify({message: 'L\'article a bien été enregistrée', type: 'success', verticalAlign: 'bottom'})
              this.backToList();
            })
          }

        }
      })
    }
  }
}
</script>

<style lang="scss">

</style>
